(function () {
  function initCountdown(root) {
    if (!root || root.dataset.jb2CountdownReady === 'true') return;

    var target = Date.parse(root.dataset.launchDate || '2026-08-21T09:00:00-04:00');
    if (Number.isNaN(target)) return;

    var values = {
      days: root.querySelector('[data-jb2-days]'),
      hours: root.querySelector('[data-jb2-hours]'),
      minutes: root.querySelector('[data-jb2-minutes]'),
      seconds: root.querySelector('[data-jb2-seconds]')
    };

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function tick() {
      var remaining = Math.max(0, target - Date.now());
      var days = Math.floor(remaining / 86400000);
      remaining -= days * 86400000;
      var hours = Math.floor(remaining / 3600000);
      remaining -= hours * 3600000;
      var minutes = Math.floor(remaining / 60000);
      remaining -= minutes * 60000;
      var seconds = Math.floor(remaining / 1000);

      if (values.days) values.days.textContent = pad(days);
      if (values.hours) values.hours.textContent = pad(hours);
      if (values.minutes) values.minutes.textContent = pad(minutes);
      if (values.seconds) values.seconds.textContent = pad(seconds);

      if (target <= Date.now() && root._jb2CountdownTimer) {
        window.clearInterval(root._jb2CountdownTimer);
        root._jb2CountdownTimer = null;
      }
    }

    root.dataset.jb2CountdownReady = 'true';
    tick();
    root._jb2CountdownTimer = window.setInterval(tick, 1000);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-jb2-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-jb2-countdown]');
    if (root && root._jb2CountdownTimer) window.clearInterval(root._jb2CountdownTimer);
  });
})();
